import {
  Anchor,
  Burger,
  Container,
  createStyles,
  Group,
  Header,
  MediaQuery,
  useMantineTheme,
} from "@mantine/core";
import { useRouterContext } from "@hooks";
import logo from "../../assets/images/wmp-logo.svg";

const useStyles = createStyles((theme) => ({
  header: {
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
  },

  inner: {
    height: 56,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  links: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  link: {
    display: "block",
    lineHeight: 1,
    padding: "8px 12px",
    borderRadius: theme.radius.sm,
    textDecoration: "none",
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[0]
        : theme.colors.gray[7],
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,

    "&:hover": {
      textDecoration: "none",
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },

  logo: {
    width: 180,
    [theme.fn.smallerThan("sm")]: {
      width: 120,
    },
  },
}));

interface LandingHeaderProps {
  toggleOpen: () => void;
  opened: boolean;
}

export const LandingHeader = ({ toggleOpen, opened }: LandingHeaderProps) => {
  const theme = useMantineTheme();
  const { Link } = useRouterContext();
  const { classes } = useStyles();

  return (
    <Header
      height={{ base: 60, md: 100 }}
      p="md"
      data-testid="landingpage-header"
    >
        <Group position="apart" sx={{ alignItems: "center", height: "100%" }}>
          <Group>
            <MediaQuery largerThan="sm" styles={{ display: "none" }}>
              <Burger
                opened={opened}
                onClick={toggleOpen}
                size="sm"
                color={theme.colors.gray[6]}
                mr="xl"
              />
            </MediaQuery>
            <Anchor href="/">
              <img src={logo} alt="Woolworth MarketPlus" className={classes.logo} />
            </Anchor>
          </Group>
          <Group ml={50} spacing={5} className={classes.links}>
            <Link to={`/login`} className={classes.link}>
              <span>Log In</span>
            </Link>
            <Anchor
              href={`https://sellerhelp.woolworthsmarketplus.com.au/hc/en-gb`}
              className={classes.link}
              target="_blank"
            >
              Help
            </Anchor>
            <Anchor
              href={`https://seller-forms.mydeal.com.au/mydealcomau/form/WMPSellerApplication/formperma/lBdNglYcopeb-2O2fv6q-aKGh-4GB6EWI6H1X6jKov4`}
              className={classes.link}
              target="_blank"
            >
              Contact
            </Anchor>
          </Group>
          {/* Only show Log In on true mobile screens (max-width: 600px) */}
          <MediaQuery largerThan={600} styles={{ display: "none" }}>
            <Link to={`/login`} className={classes.link} style={{ marginLeft: 16 }}>
              <span>Log In</span>
            </Link>
          </MediaQuery>
        </Group>
    </Header>
  );
};
